import { useState } from "react";
import { useAppStore } from "store";
import { useUserAvatarImageUrl } from "hooks/useUserAvatar";
import { AiOutlineLoading } from "react-icons/ai";

const avatarPlaceholder = require("assets/img/avatar-silhouette.png");

interface AvatarCharacterProps extends React.HTMLAttributes<HTMLDivElement> {
  responsive?: boolean;
  flip?: boolean;
  defaultAvatarUrl?: string;
  size?: 'normal' | 'large'; 
  userId?: string; 
}

export default function AvatarCharacter({
  flip,
  responsive,
  defaultAvatarUrl,
  size = 'normal',
  userId,
}: AvatarCharacterProps) {
  const { user } = useAppStore();
  const [avatarError, setAvatarError] = useState(false);
  const { avatarImageUrl, isLoading, error } = useUserAvatarImageUrl(userId || user?._id);

  const getAvatarStyles = () => {
    if (size === 'large') {
      return {
        width: '140%',
        height: '110%',
        bottom: '-5%',
        left: '50%',
        transform: 'translateX(-50%) scale(1)',
        objectFit: 'contain' as const,
        objectPosition: 'center bottom',
        zIndex: 10,
        maxWidth: 'none',
        maxHeight: 'none'
      };
    }
    
    return {
      width: '100%',
      height: '90%',
      bottom: '0%',
      left: '50%',
      transform: 'translateX(-50%) scale(1)',
      objectFit: 'contain' as const,
      objectPosition: 'center bottom',
      zIndex: 10,
      maxWidth: 'none',
      maxHeight: 'none'
    };
  };

  if (isLoading) {
    return (
      <div
        className={
          responsive
            ? `relative w-full aspect-[1/1.6] flex items-center justify-center`
            : `w-64 relative aspect-[1/1.6] flex items-center justify-center`
        }
      >
        <div className="flex items-center justify-center bg-white/10 rounded-full p-4 backdrop-blur-sm">
          <AiOutlineLoading
            size={32}
            className="animate-spin text-brand-orange"
          />
        </div>
      </div>
    );
  }

  if (avatarImageUrl && !error && !avatarError) {
    return (
      <div
        className={
          responsive
            ? `relative w-full aspect-[1/1.6] overflow-visible`
            : `w-64 relative aspect-[1/1.6] overflow-visible`
        }
        style={{ overflow: 'visible' }}
      >
        <img
          src={avatarImageUrl}
          alt="Avatar do usuário"
          className={`absolute ${flip ? "-scale-x-100" : ""}`}
          style={getAvatarStyles()}
          onError={(e) => {
            setAvatarError(true);
          }}
        />
      </div>
    );
  }

  if (defaultAvatarUrl) {
    return (
      <div
        className={
          responsive
            ? `relative w-full aspect-[1/1.6] overflow-visible`
            : `w-64 relative aspect-[1/1.6] overflow-visible`
        }
        style={{ overflow: 'visible' }}
      >
        <img
          src={defaultAvatarUrl}
          alt="Avatar padrão"
          className={`absolute ${flip ? "-scale-x-100" : ""}`}
          style={getAvatarStyles()}
          onError={(e) => {
            console.warn('⚠️ AvatarCharacter: Erro ao carregar avatar padrão');
          }}
        />
      </div>
    );
  }

  return (
    <div
      className={
        responsive
          ? `relative w-full aspect-[1/1.6]`
          : `w-64 relative aspect-[1/1.6]`
      }
    >
      <img
        src={avatarPlaceholder}
        alt="Avatar placeholder"
        className={`absolute w-full h-full ${flip ? "-scale-x-100" : ""}`}
        style={{
          objectFit: 'contain',
          objectPosition: 'center center',
        }}
      />
    </div>
  );
}
